import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import { useEffect, useRef } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import PersonSelector from '@/components/PersonSelector';
// import { useApproveForm } from '@/store/flowFormStore';
import { useApproveForm, useApproveUsers } from '@/store/flowExcelStore';
import { useRequest, useUnmount } from 'ahooks';
import { getAssignees } from '@/services';
const {
  Row,
  Col
} = _Grid;
const FormItem = _Form.Item;
function ApproveForm({
  type,
  showComment,
  bizId,
  processVersion,
  eventId
}) {
  const [approveUsers] = useApproveUsers();
  const [approveForm] = _Form.useForm();
  useApproveForm(approveForm);
  const {
    run
  } = useRequest(getAssignees, {
    manual: true,
    onSuccess: response => {
      approveForm.setFieldsValue(response);
    }
  });
  useUnmount(() => {
    approveForm.resetFields();
  });
  useEffect(() => {
    if (bizId) {
      run(bizId);
    }
  }, [bizId, run]);

  // 记录上一次的审批节点 value，用于精确重置。
  const prevApproveValuesRef = useRef([]);
  // 审批节点变化时，只清掉「被移除节点」的字段值；
  // 整表 resetFields() 会把 init / getAssignees 写入的默认审批人及用户已选值一起清空。
  useEffect(() => {
    if (!approveUsers.length) return;
    const values = approveUsers.map(node => node.value);
    const removed = prevApproveValuesRef.current.filter(value => !values.includes(value));
    prevApproveValuesRef.current = values;
    if (removed.length) {
      approveForm.resetFields(removed);
    }
  }, [approveUsers, approveForm]);
  return /*#__PURE__*/React.createElement(_Form, {
    form: approveForm,
    disabled: type === 'view'
  }, /*#__PURE__*/React.createElement("div", {
    className: "lx-approve-user lx-table-title-name"
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null, "\u5BA1\u6279\u4EBA")), /*#__PURE__*/React.createElement(Row, {
    gutter: 16
  }, approveUsers.map(node => {
    const nameField = `${node.value}Name`;
    const data = node.data || {};
    const notRequired = data.data?.notRequired || [];
    const notDisabled = data.data?.notDisabled || [];
    if (!notDisabled.length) {
      notDisabled.push('start');
    }
    const version = data.data?.version;

    // 非必填
    const isNotRequired = notRequired.length ? notRequired.includes(eventId) : false;

    // 非禁用
    const isNotDisabled = notDisabled.length ? notDisabled.includes(eventId) : false;
    const isDisabled = !isNotDisabled;
    // 禁用的字段用户无法填写，不能再挂 required，否则校验永远失败
    const isRequired = !isNotRequired;
    if (version > processVersion) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/React.createElement(Col, {
      key: node.uid,
      span: 8
    }, /*#__PURE__*/React.createElement(FormItem, {
      field: node.value,
      label: node.text,
      rules: isRequired ? [{
        required: true,
        message: `请选择${node.text}`
      }] : []
    }, /*#__PURE__*/React.createElement(PersonSelector, {
      type: "checkbox",
      form: approveForm,
      labelKey: nameField,
      disabled: isDisabled
      // 后端审批人协议是逗号拼接字符串（单人/多人都一样），
      // 必须显式声明 comma：默认 array 会把 "id1,id2" 当成单个 id，
      // 导致多人节点只回显第一个人。
      ,
      valueFormat: "comma",
      placeholder: `请选择${node.text}`
    })));
  })), showComment && /*#__PURE__*/React.createElement(FormItem, {
    label: "\u5904\u7406\u610F\u89C1",
    field: "comment"
  }, /*#__PURE__*/React.createElement(_Input.TextArea, {
    showWordLimit: true,
    className: "lx-approved-info",
    maxLength: 200,
    rows: 4,
    placeholder: "\u8BF7\u8F93\u5165\u5904\u7406\u610F\u89C1"
  })));
}
export { ApproveForm };